import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

interface DeadlinePeriodProps {
  deadlineDate: string
}

const CardDeadlinePeriod: FC<DeadlinePeriodProps> = ({ deadlineDate }) => {
  const isDeadlineVisible =
    process.env.NEXT_PUBLIC_SKP_SHOW_DEADLINE_PENILAIAN_ENABLED === 'true'

  if (!isDeadlineVisible) return null

  return (
    <div className="flex">
      <Text
        variant="eyebrow-md"
        color="subdued"
        className="bg-surface-selected-default p-2"
      >
        Kami sarankan untuk selesai sebelum:{' '}
        <strong className="text-icon-informational">{deadlineDate}</strong>
      </Text>
    </div>
  )
}

export default CardDeadlinePeriod
